import { render, staticRenderFns } from "./downvote.vue?vue&type=template&id=792b8a72&scoped=true"
import script from "./downvote.vue?vue&type=script&lang=ts"
export * from "./downvote.vue?vue&type=script&lang=ts"
import style0 from "./downvote.vue?vue&type=style&index=0&id=792b8a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792b8a72",
  null
  
)

export default component.exports